import Vue from 'vue';

export const version = '1.0.0';

const compatible = (/^2\./).test(Vue.version);
if (!compatible) {
  Vue.util.warn(`Charcounter ${version} only supports Vue 2.x, and does not support Vue ${Vue.version}`);
}

export const charcounter = {
  bind(el, binding, vnode) {
    // finding textarea
    const textarea = el.querySelector('textarea');
    if (textarea === null) {
      Vue.util.warn('charcounter only work on textarea');
      return;
    }

    // find maxlength attribute
    const maxlength = vnode.componentInstance.maxlength;
    if (maxlength === undefined) {
      Vue.util.warn('charcounter only work on textarea with maxlength');
      return;
    }

    // create element
    const span = document.createElement('span');
    span.className = 'el-textarea__charcounter';
    const count = vnode.componentInstance.currentValue.length;
    span.innerText = `${count} / ${maxlength}`;

    // begin HTML manipulation
    el.appendChild(span);
  },
  update(el, binding, vnode) {
    const span = el.querySelector('.el-textarea__charcounter');
    if (span !== undefined) {
      const maxlength = vnode.componentInstance.maxlength;
      const count = vnode.componentInstance.currentValue.length;
      span.innerText = `${count} / ${maxlength}`;
    }
  },
  unbind(el) {
    const span = el.querySelector('.el-textarea__charcounter');
    if (span !== undefined) {
      el.removeChild(span);
    }
  },
};

export const mixin = {
  directives: {
    charcounter,
  },
};
